
($ => {
	$('#bypassBlock').click(() => {
		// List of focusable tags
		const focusableTags = " a[href]:not([tabindex='-1']),area[href]:not([tabindex='-1']),input:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']),textarea:not([disabled]):not([tabindex='-1']),button:not([disabled]):not([tabindex='-1']),iframe:not([tabindex='-1']),[tabindex]:not([tabindex='-1']),[contentEditable=true]:not([tabindex='-1'])";
		// Add your class that can help find the main content
		const $mainTag = $('main, .main-content, .main');
		// Verify that there's a main tag available
		const haveMainTag = $mainTag.length > 0;
		// If not, we will use the header as the thing to skip
		const $header = $('header');
		// Choose the right tag to focus depending the context
		const focusableElement = haveMainTag ? $mainTag.find(focusableTags).first() : $header.next().find(focusableTags).first();
		// Focus the choosen element
		focusableElement.focus();
	});
})(jQuery);
